import React, { useEffect } from 'react';
import { View, Text, StyleSheet, Animated } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useOnboardingProgress } from '@/contexts/OnboardingProgressContext';

interface OnboardingLayoutProps {
  children: React.ReactNode;
  progressWidth: number;
  transparentHeader?: boolean;
  title?: string;
  header?: React.ReactNode;
}

export default function OnboardingLayout({ children, progressWidth, transparentHeader = false, title = 'Onboarding', header }: OnboardingLayoutProps) {
  const { progressAnim, setProgress } = useOnboardingProgress();

  useEffect(() => {
    setProgress(progressWidth);
  }, [progressWidth]);

  const animatedWidth = progressAnim.interpolate({
    inputRange: [0, 100],
    outputRange: ['0%', '100%'],
  });

  return (
    <SafeAreaView style={[styles.container, transparentHeader && styles.containerTransparent]} edges={['top']}>
      {/* Fixed Header */}
      {header ? header : (
        <View style={[styles.header, transparentHeader && styles.headerTransparent]}>
          <View style={styles.placeholder} />
          <View style={styles.titleContainer}>
            <Text style={[styles.headerTitle, transparentHeader && styles.headerTitleWhite]}>{title}</Text>
          </View>
          <View style={styles.placeholder} />
        </View>
      )}

      {/* Fixed Progress Bar */}
      <View style={styles.progressContainer}>
        <View style={[styles.progressBar, transparentHeader && styles.progressBarWhite]}>
          <Animated.View style={[styles.progress, transparentHeader && styles.progressWhite, { width: animatedWidth }]} />
        </View>
      </View>

      {/* Scrollable Content */}
      {children}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F9F8F3',
  },
  containerTransparent: {
    backgroundColor: 'transparent',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    paddingVertical: 16,
    height: 56,
  },
  headerTransparent: {
    backgroundColor: 'transparent',
  },
  titleContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    color: '#151515',
    textAlign: 'center',
    fontFamily: 'Inter_700Bold',
    fontSize: 14,
    lineHeight: 14,
  },
  headerTitleWhite: {
    color: '#FFFFFF',
  },
  placeholder: {
    width: 24,
    height: 24,
  },
  progressContainer: {
    paddingHorizontal: 24,
    paddingBottom: 16,
  },
  progressBar: {
    backgroundColor: '#DAD8CF',
    height: 2,
    width: '100%',
    borderRadius: 1,
  },
  progressBarWhite: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  progress: {
    backgroundColor: '#015480',
    height: '100%',
    borderRadius: 1,
  },
  progressWhite: {
    backgroundColor: '#FFFFFF',
  },
});
